module.exports = __webpack_public_path__ + "redeemed-badge.svg?d090d7d5862e4f0851cf50a77571c5e3";